import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { BackButton } from '@app/core';
import { Trans } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100vw',
  },
  content: {
    width: '100%',
    maxWidth: theme.maxContentWidth.reduced,

    margin: 'auto',
    marginTop: theme.marginBase * 15,

    padding: theme.marginBase,

    [theme.media.tablet]: {
      marginTop: theme.marginBase * 10,
    },
  },
  title: {
    ...theme.fonts.h3,
  },
  backButton: {
    marginBottom: theme.marginBase * 3,
  },
  illustration: {
    width: theme.marginBase * 20,
  },
  illustrationContainer: {
    textAlign: 'center',
  },
}));

interface Props {
  children?: React.ReactNode;
  withPrevious?: boolean;
  title?: string;
  illustration?: string;
}

export const CleanCenteredPage = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        {props.withPrevious && (
          <BackButton color="ink" className={classes.backButton} />
        )}
        {props.illustration && (
          <div className={classes.illustrationContainer}>
            <img
              src={props.illustration}
              alt="Illustration"
              className={classes.illustration}
            />
          </div>
        )}
        {props.title && <h1 className={classes.title}>{props.title}</h1>}
        {props.children}
      </div>
    </div>
  );
};
